import React, {useEffect} from 'react';
import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BottomMenu from './main/BottomMenu';
import SocketController from './SocketController';
import CachingController from './CachingController';
import { useEffectAsync } from './reactHelper';
import { sessionActions } from './store';
import { refreshTotalCounts } from './work/utils/refreshTotalCountsUtils'; // Import your utility function
import { refreshDriverInstructions } from './work/utils/refreshDriverInstructionsUtils'; // Import your utility function
import LoadingPage from './LoadingPage';  // Adjust the path based on your directory structure


const useStyles = makeStyles(() => ({
  page: {
    flexGrow: 1,
    overflow: 'auto',
  },
  menu: {
    zIndex: 4,
    width:'100%',
  },
}));

const App = () => {

  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const newServer = useSelector((state) => state.session.server.newServer);
  const initialized = useSelector((state) => !!state.session.user);

  const [timestamp, setTimestamp] = useState(Date.now());
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.session.user);

  // const device = useSelector((state) => state.session.device);
  // const driverInstructions = useSelector((state) => state.session.driverInstructions);

  useEffectAsync(async () => {
    if (!initialized) {
      try{
        const response = await fetch('/api/session');
        if (response.ok) {
          const data = await response.json();
          dispatch(sessionActions.updateUser(data));
        } else if (response.status === 404) {
          console.warn("Session not found, redirecting to login");
          navigate('/login');  // Handle session expired or missing
        } else if (newServer) {
          navigate('/register');
        } else {
          navigate('/login');
        }
      }catch(e){
        console.warn(e);
        navigate('/login');
      }
      
    }
    return null;
  }, [initialized]);  
  
  const classes = useStyles();
  const theme = useTheme();

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  // DEVICES
  useEffectAsync(async () => {
    if (user && user.id) {
      setLoading(true);
      try {
        const response = await fetch(`/api/devices?userId=${user.id}`);
        if (response.ok && response.status !== 204) {
          const devicesData = await response.json();  // Check if the body is not empty
          if (devicesData && devicesData.length>0) {
            dispatch(sessionActions.updateDevice(devicesData));
          }
        } else {
          throw Error(await response.text());
        }
      } finally {
        setLoading(false);
      }
    }
  }, [user, timestamp]);


  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          refreshDriverInstructions(user, dispatch),
          refreshTotalCounts(user, dispatch)
        ]);
      } catch (err) {
        console.warn("Offline fallback or error loading data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      loadData();
    }
  }, [user, dispatch]);

  
  

  // NOTIFICATIONS
  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/notifications');
      if (response.ok && response.status !== 204) {  // Handle case when there is no content (status 204)
        const notifications = await response.json();  // Only parse if there's content
        dispatch(sessionActions.updateNotifications(notifications));
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  /*if ((navigate && navigate.state === 'loading') || loading) {
    return <LoadingPage />;
  }*/

  return !initialized ? (<LinearProgress />) : (
    <>
      <SocketController />
      <CachingController />
      {!loading ?
        <div className={classes.page}>
          <Outlet />
        </div>
        :
        <div className={classes.loading}>
          <Outlet />
        </div>
      }
        <div className={classes.menu}>
          <BottomMenu />
        </div>
    </>
  );
};

export default App;
